import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BeneficiaryService } from '../../../shared/services/beneficiary.service';
import { SessionService } from '../../../shared/services/session.service';
import { Beneficiary } from '../../../shared/models/beneficiary.model';
import { UserService } from '../../../shared/services/user.service';

import swal from 'sweetalert2';

declare var jQuery: any;

@Component({
  selector: 'app-home-medical',
  templateUrl: './home-medical.component.html',
  styleUrls: ['./home-medical.component.css']
})
export class HomeMedicalComponent implements OnInit {

  beneficiaries: Beneficiary[];

  showSpinner: boolean;

  collapseInDatosContrato = false;

  estado = false;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private beneficiaryService: BeneficiaryService,
    private _sessionService: SessionService,
    private _userService: UserService
  ) { }

  ngOnInit() {

    this.showSpinner = true;

    //this.beneficiaryService.getBeneficiariesMedical(this._sessionService.getSelectContract(), this._sessionService.getCurrentUser().documentId, 
    //this._sessionService.getSelectDocumentTypeContracted()).subscribe(
    this.beneficiaryService.getBeneficiariesMedicalPanacea(this._sessionService.getSelectContract(), this._sessionService.getCurrentUser().documentId,
      this._sessionService.getSelectDocumentTypeContracted()).subscribe(
      res => {
        this.beneficiaries = res;
        console.log(this.beneficiaries);
        
        /*
        let _res: Beneficiary[];

        //Usuario menor de edad
        if (this._sessionService.getCurrentUser().age < 18) {
          let i: number;
          i = 0;
          for (let usuario of res) {
            if (usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId) {
              this.beneficiaries = Array<Beneficiary>(res[i]);
            }
            i++;
          }
        }
        else {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            _array.push(usuario);
            j++;
          }

          this.beneficiaries = _array;
        }
        */
        /*else {
          
          if(this._sessionService.getCurrentUser().actualizacionMenu){
            //Usuario contratante
            let j : number;
            j = 0;
            var _array = [];
            
            for (let usuario of res){
                if(usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId
                  || usuario.edad < 18){
                  _array.push(usuario);
                }
                j++;
            }

            this.beneficiaries = _array;
          }
          else {
            //Usuario beneficiario mayor de edad
            let k : number;
            k = 0;
            var _array = [];
            
            for (let usuario of res){
                if(usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId
                  || usuario.edad < 18){
                  _array.push(usuario);
                }
                k++;
            }

            this.beneficiaries = _array;
          }
        }*/

        this.showSpinner = false;
      },
      err => {
        this.showSpinner = false;
        console.log(err);
      }
      )
  }

  solicitarCita(documento: string, nombre: string, carne: string, edad:string) {
    
    //this._userService.getStatusUser(documento).subscribe(
    this._userService.getStatusUserPanacea(documento).subscribe(
      res => {
        
        if (res.message === 'A') {

          sessionStorage.removeItem('nombreBeneficiario');
          sessionStorage.removeItem('documentoBeneficiario');
          sessionStorage.removeItem('edad');
          sessionStorage.setItem('nombreBeneficiario', nombre);
          sessionStorage.setItem('documentoBeneficiario', documento);
          sessionStorage.setItem('carneBeneficiario', carne);
          sessionStorage.setItem('edad', edad);
          this._router.navigate(['/office/medical_appointment/request']);

        } else if (res.message === 'I') {
          swal({
            title: 'Solicitud Cita Médica',
            html: '<p style="font-size:14px">Lo sentimos el usuario ha superado el límite de solicitudes</p>',
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        } else {

          swal({
            title: 'No Disponible',
            html: '<p style="font-size:14px">Lo sentimos en estos momentos el módulo de solicitud de citas médicas no se encuentra disponible</p>',
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });

        }

      },
      err => {
        console.log(err);
        swal({
          title: 'Solicitud Cita Médica',
          html: '<p style="font-size:14px">Lo sentimos se ha presentado un inconveniente. Por favor intente nuevamente</p>',
          type: 'error',
          confirmButtonClass: 'btn btn-primary',
          buttonsStyling: false,
          focusConfirm: false
        });

      }
    );
  }

  consultarCita(documento: string, nombre: string) {
    sessionStorage.removeItem('nombreBeneficiario');
    sessionStorage.removeItem('documentoBeneficiario');
    sessionStorage.setItem('nombreBeneficiario', nombre);
    sessionStorage.setItem('documentoBeneficiario', documento);
    this._router.navigate(['/office/medical_appointment/consult']);
  }

  clickPanelHeadindDatosContrato() {
    this.collapseInDatosContrato = !this.collapseInDatosContrato;
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/medical-appointment/home-medical/home-medical.component.ts